import { httpGet } from '../../../utils/api.utils';
import { actions } from 'react-redux-form';
import Moment from 'moment';

import {
    getAddCostAllocation,
    addCostAllocationDetails,
    deleteCostAllocationDetails,
    circuitCostAllocationFormModel,
    updateCircuitCostAllocationItem,

} from '../../../constants/model-reducers/external/inventory/circuit-details/add-cost-allocation.settings';

export const circuitCostAllocationFormInitialState = circuitCostAllocationFormModel;

const defaultState = () => ({
    circuitCostAllocation: {
        datatable: [],
        totalCostCodePercent: 0
    },
});

const initialState = defaultState();

export const inventoryCostAllocationActions = {
    getAddCostAllocation: (circuitID) => async (dispatch, state) => {
        var circuitCostAllocation = await httpGet('external/inventory/getAddCostAllocation?circuitId=' + circuitID);

        dispatch({
            type: getAddCostAllocation,
            circuitCostAllocation: circuitCostAllocation
        });
    },

    addCostAllocationDetails: (data, totalCostCodePercent) => async (dispatch, state) => {
        const { inventoryCircuitCostAllocationForm } = state().form;
        const { datatable } = state().inventoryCostAllocation.circuitCostAllocation;
        var lastModified = data.LastModified;        ;
        var circuitGlCodeList = await httpGet('external/autosuggest/getGLCodeDetails/' + sessionStorage.EmployeeID + '?val=' + data.GLCode);
        var circuitCostCenterList = await httpGet('external/autosuggest/getCostCenterDetails/' + sessionStorage.EmployeeID + 
        '?val=' + data.CostCode + '&companycode=' + inventoryCircuitCostAllocationForm.CompanyCode);


        var glCodeName = '';
        var glCodeId = '';
        var glCode = '';
        if (circuitGlCodeList.length > 0) {
            glCodeName = circuitGlCodeList[0].Name;
            glCodeId = circuitGlCodeList[0].GlcodeId;
            glCode = circuitGlCodeList[0].Glcode;
        }

        var companyCode = inventoryCircuitCostAllocationForm.CompanyCode;
        var costCodeId = '';
        var costCode = '';
        if (circuitCostCenterList.length > 0) {            
            costCodeId = circuitCostCenterList[0].CostCodeId;
            costCode = circuitCostCenterList[0].CostCenter;
        }

        var dataItem = datatable[0].dataItem
        var HeaderItem = datatable[0].HeaderItem

        var newCostAllocation = [
            ...dataItem,
            {
                ...circuitCostAllocationFormModel,
                CostCodeID: costCodeId,
                CostCode: costCode,
                CompanyCode: companyCode,
                GLCodeID: glCodeId,
                GLCode: glCode,
                GLCodeName: glCodeName,
                CostCodePercent: parseFloat(data.CostCodePercent),
                LastModified: lastModified
            }
        ];

        var newDataTable = [{
            dataItem: newCostAllocation,
            HeaderItem: HeaderItem,
        }];

        dispatch({
            type: addCostAllocationDetails,
            datatable: newDataTable,
            totalCostCodePercent: totalCostCodePercent
        })
    },

    updateCircuitCostAllocationItem: (indexItem) => async (dispatch, state) => {
        const { datatable } = state().inventoryCostAllocation.circuitCostAllocation;
        const { inventoryCircuitCostAllocationForm } = state().form;

        var circuitGlCodeList = await httpGet('external/autosuggest/getGLCodeDetails/' + sessionStorage.EmployeeID + '?val=' + inventoryCircuitCostAllocationForm.GLCode);
        var circuitCostCenterList = await httpGet('external/autosuggest/getCostCenterDetails/' + sessionStorage.EmployeeID + 
                                                '?val=' + inventoryCircuitCostAllocationForm.CostCode + '&companycode=' + inventoryCircuitCostAllocationForm.CompanyCode);


        var glCodeName = '';
        var glCodeId = '';
        var glCode = '';
        if (circuitGlCodeList.length > 0) {
            glCodeName = circuitGlCodeList[0].Name;
            glCodeId = circuitGlCodeList[0].GlcodeId;
            glCode = circuitGlCodeList[0].Glcode;
        }

        var companyCode = '';
        var costCodeId = '';
        var costCode = '';

        if(inventoryCircuitCostAllocationForm.CompanyCode) {
            companyCode = inventoryCircuitCostAllocationForm.CompanyCode;
        } else {
            companyCode = datatable[0].dataItem[indexItem].CompanyCode
        }

        if (circuitCostCenterList.length > 0) {
            costCodeId = circuitCostCenterList[0].CostCodeId;
            costCode = circuitCostCenterList[0].CostCenter;
        }

        var dataItem = datatable[0].dataItem
        var HeaderItem = datatable[0].HeaderItem

        var lastModified = sessionStorage.FirstName + ' ' + sessionStorage.LastName + ' ' + 'on' + ' ' + Moment(new Date()).format('L').toString() + ' ' + Moment(new Date()).format('LT');
        dataItem[indexItem] = {
            ...inventoryCircuitCostAllocationForm,
            CostAllocationID: dataItem[indexItem].CostAllocationID,
            CostCodePercent: parseFloat(inventoryCircuitCostAllocationForm.CostCodePercent),
            GLCodeName: glCodeName,
            GLCodeID: glCodeId,
            GLCode: glCode,
            CostCodeID: costCodeId,
            CompanyCode: companyCode,
            CostCode: costCode,
            LastModified: lastModified,
        };

        var totalCostCodePercent = 0;
        totalCostCodePercent = dataItem.reduce(
            (total, item) => total + parseFloat(item.CostCodePercent),
            0
        );

        var newDataTable = [{
            dataItem: dataItem,
            HeaderItem: HeaderItem,
        }];

        dispatch({
            type: updateCircuitCostAllocationItem,
            datatable: newDataTable,
            totalCostCodePercent: totalCostCodePercent
        });
    },

    deleteCostAllocationDetails: (index) => (dispatch, state) => {
        const { datatable } = state().inventoryCostAllocation.circuitCostAllocation;

        var dataItem = datatable[0].dataItem
        var HeaderItem = datatable[0].HeaderItem

        var newDataItem = [...dataItem]
        newDataItem.splice(index, 1)
        var newCostAllocationList = newDataItem


        var totalCostCodePercent = 0;
        totalCostCodePercent = newDataItem.reduce(
            (total, item) => total + parseFloat(item.CostCodePercent),
            0
        );


        var newDataTable = [{
            dataItem: newCostAllocationList,
            HeaderItem: HeaderItem,
        }]

        dispatch({
            type: deleteCostAllocationDetails,
            datatable: newDataTable,
            totalCostCodePercent: totalCostCodePercent
        });
    },
}
    
    

export const reducer = (state, action) => {
    state = state || initialState;

    switch (action.type) {
        case getAddCostAllocation:
            return {
                ...state,
                circuitCostAllocation: action.circuitCostAllocation,
            };
        case addCostAllocationDetails:
            return {
                ...state,
                circuitCostAllocation: {
                    ...state.circuitCostAllocation,
                    datatable: action.datatable,
                    totalCostCodePercent: action.totalCostCodePercent
                },
            };
        case deleteCostAllocationDetails:
            return {
                ...state,
                circuitCostAllocation: {
                    ...state.circuitCostAllocation,
                    datatable: action.datatable,
                    totalCostCodePercent: action.totalCostCodePercent
                },
            };
        case updateCircuitCostAllocationItem:
            return {
                ...state,
                circuitCostAllocation: {
                    ...state.circuitCostAllocation,
                    datatable: action.datatable,
                    totalCostCodePercent: action.totalCostCodePercent
                }
            };
 
        default:
        return state;
    }

};